module.exports = __webpack_public_path__ + "img/1.aaf761c.jpg";